// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { makeStyles, Box, Icon } from '@material-ui/core';
import { GridOverlay } from '@material-ui/data-grid';
import { DataTable, EmptyState } from '../../../../../common/components';

const useStyles = makeStyles(theme => ({
  container: {
    flex: '1',
    minHeight: '500px',
    '& .MuiDataGrid-root': {
      border: '0',
    },
  },
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  red: {
    color: theme.palette.error.main,
  },
}));

function CustomerSearchResults(props) {
  const [t] = useTranslation();
  const classes = useStyles();

  const { data, onSelectCustomer, onFetchData } = props;

  /* eslint-disable react/no-danger */

  const getColumnDefs = () => [
    {
      field: 'disabled',
      headerName: t('user.userDisabled'),
      width: 60,
      sortable: false,
      disableColumnMenu: true,
      type: 'boolean',
      renderHeader: () => <div>&nbsp;</div>,
      renderCell: params => params.row.blockedStatus && <Icon color="error">error</Icon>,
    },
    {
      field: 'email',
      headerName: t('user.userEmail'),
      flex: 1,
      renderCell: params => (
        <div className={classes.text} dangerouslySetInnerHTML={{ __html: params.value }} />
      ),
    },
    {
      field: 'firstname',
      headerName: t('user.userFirstName'),
      flex: 0.75,
      renderCell: params => (
        <div className={classes.text} dangerouslySetInnerHTML={{ __html: params.value }} />
      ),
    },
    {
      field: 'cellphone',
      headerName: t('user.userCellPhone'),
      flex: 0.75,
      renderCell: params => (
        <div className={classes.text} dangerouslySetInnerHTML={{ __html: params.value }} />
      ),
    },
    {
      field: 'emailVerified',
      headerName: t('user.userVerified'),
      width: 150,
      filterable: false,
      cellClassName: params => clsx({ [classes.red]: !params.value }),
      valueFormatter: params => (params.value ? 'Ja' : 'Nej'),
    },
    {
      field: 'status',
      headerName: t('user.userAccountStatus'),
      width: 175,
      cellClassName: params => clsx({ [classes.red]: params.value === 'Lukket' }),
    },
    {
      field: 'blockedStatus',
      headerName: t('user.userBlocked'),
      width: 150,
      filterable: false,
      cellClassName: params => clsx({ [classes.red]: params.value }),
      valueFormatter: params => (params.value ? 'Ja' : 'Nej'),
    },
    {
      field: 'userId',
      headerName: t('user.userId'),
      flex: 0.75,
      renderCell: params => (
        <div className={classes.text} dangerouslySetInnerHTML={{ __html: params.value }} />
      ),
    },
    {
      field: 'subscriptionStatus',
      headerName: t('user.userSubscriptionStatus'),
      width: 225,
      cellClassName: params => clsx({ [classes.red]: params.value === 'Lukket' }),
    },
  ];

  /* eslint-enable react/no-danger */

  const getRowData = () =>
    data.users.map(user => {
      const { userId, email, firstname, cellphone, highlight, ...rest } = user;

      return {
        ...rest,
        id: userId,
        email: highlight?.email?.[0] || highlight?.['email.email_standard']?.[0] || email,
        firstname: highlight?.firstname?.[0] || firstname,
        cellphone: highlight?.cellphone?.[0] || cellphone,
        userId: highlight?.user_id?.[0] || userId,
      };
    });

  const renderNoRowsOverlay = () => (
    <GridOverlay>
      <EmptyState variant="empty" message={t('customer.customerSearchResultsEmpty')} />
    </GridOverlay>
  );

  return (
    <Box id="CustomerSearchResults-container" className={classes.container}>
      <DataTable
        id="CustomerSearchResults-table"
        components={{
          NoRowsOverlay: renderNoRowsOverlay,
        }}
        columns={getColumnDefs()}
        rows={getRowData()}
        rowCount={data.total}
        pageSize={data.limit}
        pageIndex={data.start}
        onRowClick={onSelectCustomer}
        onPageChange={onFetchData}
        paginationMode="server"
        pagination
      />
    </Box>
  );
}

CustomerSearchResults.propTypes = {
  data: PropTypes.shape({
    length: PropTypes.number,
    limit: PropTypes.number,
    start: PropTypes.number,
    total: PropTypes.number,
    users: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  onSelectCustomer: PropTypes.func.isRequired,
  onFetchData: PropTypes.func.isRequired,
};

export default CustomerSearchResults;
